import PropTypes from 'prop-types';
import {map as _map, get as _get} from 'lodash';

import {getYesOrNo} from '@utils/helpers';
import {getSlaThresholdForExcel} from '@utils/sla/slaThreshold';
import {sortByTextValue} from '@utils/sorters';

export const clientPackagesExportExcel = (dataExport) => ({
    dataExport: dataExport,
    filename: 'client_packages',
    parseData: client_package => [
        client_package.id,
        client_package.client_product.client.id,
        _get(client_package.client_product, 'client.bookmaker.id', ''),
        client_package.client_product.client.name,
        client_package.client_product.client.brands,
        getYesOrNo(client_package.client_product.client.is_disabled),
        client_package.client_product.product.short_name,
        getYesOrNo(client_package.client_product.is_disabled),
        client_package.name,
        client_package.description,
        client_package.unique_sportradar_contract_number,
        client_package.content_activation_ticket_number ? client_package.content_activation_ticket_number.toUpperCase() : '',
        client_package.sf_contract_number,
        client_package.client_package_type.name,
        client_package.booking_type.name,
        sortByTextValue(client_package.content_package_types, 'name')
            .map(contentPackageType => contentPackageType.name).join(', '),
        _map(client_package.event_content_variants, (eventContentVariant) => eventContentVariant.name).join(', '),
        client_package.start_date,
        client_package.end_date,
        0 < client_package.client_package_geo_restrictions.length
            ? 'Specific'
            : 'Same as client product settings',
        getYesOrNo(client_package.is_hq),
        getYesOrNo(client_package.is_ll),
        getYesOrNo(client_package.is_test),
        getSlaThresholdForExcel(client_package),
        getYesOrNo(client_package.disabled),
    ],
    path: 'clientPackages.path',
    titles: [
        'ID',
        'Client ID',
        'Bookmaker ID',
        'Client name',
        'Client brands',
        'Client is disabled',
        'Product',
        'Product is disabled',
        'Package name',
        'Package description',
        'Unique Sportradar contract number',
        'Content activation ticket number',
        'SF contract number',
        'Package type',
        'Booking type',
        'Content selection',
        'Content variants',
        'Start date',
        'End date',
        'Geo restrictions',
        'HQ',
        'LL',
        'Test',
        'SLA',
        'Package is disabled',
    ],
});

clientPackagesExportExcel.propTypes = {
    dataExport: PropTypes.array.isRequired,
};
